import { useI18n } from '@/context/I18nContext';
import { AccountSettingsSection } from '@shared/settings/AccountSettingsSection';
import { LanguageDropdown } from '@shared/auth/LanguageDropdown';

export function SettingsPage() {
  const { t, locale, setLocale } = useI18n();

  return (
    <div className="space-y-10 max-w-4xl mx-auto py-6">
      <h2 className="text-xl font-semibold tracking-tight">{t('settings.title')}</h2>

      {/* Language */}
      <section>
        <h3 className="section-title mb-4">{t('settings.language')}</h3>
        <LanguageDropdown
          locale={locale}
          onChange={setLocale}
          align="left"
          testIdPrefix="settings-locale"
        />
      </section>

      {/* Account & Profile */}
      <section>
        <h3 className="section-title mb-4">{t('settings.account')}</h3>
        <AccountSettingsSection />
      </section>
    </div>
  );
}
